import { AccountType } from 'store/api/enums';
import { User } from 'store/auth/models';
import { Mapping } from 'store/organisation/models';
import { VatReturnLog } from 'store/vat/models/vatReturnLog';

/** Same split as a VAT save: staff are everyone who is not a client. */
export const splitActivityUsers = (
  members: User[] | null | undefined
): { staff: User[]; clients: User[] } => {
  const list = members ?? [];
  return {
    staff: list.filter(
      (user) => AccountType[user.accountType] !== AccountType.CLIENT
    ),
    clients: list.filter(
      (user) => AccountType[user.accountType] === AccountType.CLIENT
    ),
  };
};

export const findReturnLog = (
  mappings: Mapping[] | null | undefined,
  mappingId: string | undefined,
  reportId: string | undefined
): VatReturnLog | undefined => {
  if (!mappings || !mappingId || !reportId) return undefined;
  return mappings
    .find((mapping) => mapping.mappingId === mappingId)
    ?.dataLogs?.find((log) => log.uuid === reportId);
};

/**
 * The returns list shows preparerUser / reviewerUser / clientUser.
 * A role change updates those people immediately and only refreshes the
 * account-id fields after a full organisation reload, so the user wins.
 */
export const savedRoleIds = (
  log: VatReturnLog | undefined,
  members: User[] | null | undefined
): { preparerId?: string; reviewerId?: string; clientId?: string } => {
  const accountId = (
    user: User | null | undefined,
    accountField?: string | null,
    userField?: string | null
  ): string | undefined => {
    if (user?.accountUuid) return user.accountUuid;
    if (accountField) return accountField;
    if (!userField) return undefined;
    return members?.find((member) => member.userUuid === userField)?.accountUuid;
  };

  return {
    preparerId: accountId(
      log?.preparerUser,
      log?.savedByAccountId,
      log?.savedByUserId
    ),
    reviewerId: accountId(
      log?.reviewerUser,
      log?.reviewerAccountId,
      log?.reviewerUserId
    ),
    clientId: accountId(log?.clientUser, log?.clientAccountId, log?.clientUserId),
  };
};
